export default __webpack_public_path__ + "static/media/140.6e950470.png";